import react from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <>
      <section className="pt-44 pb-64 text-center">
        {/* Headline */}
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="kn-h1 text-white"
        >
          Kaminfeger Buchs
        </motion.h1>

        {/* Subheadline */}
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="kn-lead text-white sm:text-xl font-medium mt-4"
        >
          Sichere Lösungen. Saubere Arbeit.
        </motion.h2>

        {/* Button */}

        <Link to="/kontakt">
          <motion.button
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 300 }}
            className="kn-btn-primary mt-6"
          >
            Kontaktaufnahme
          </motion.button>
        </Link>
      </section>
    </>
  );
}
